import { SCREEN } from "../../utils/constants";
import { primaryColor, selectedGender, setSelectedGender, showBodyAreaSelection, staffId } from "../../utils/variables";
import { renderbodySelectionUI } from "../actions/bodyAreaSelectionAction";
import { bodyAreaSelectionListeners } from "./bodyAreaSelectionListeners";
import { handleCheckProviders, navigate } from "./movePages";
import { handleSelectProvider } from "./providersListeners";

export function selectGenderListeners() {
    document.querySelector('.gender__container .main_gender').style.background = `${primaryColor}09`;

    const elementsGender = document.querySelectorAll('.gender__container .main_gender .category_item');
    if (elementsGender) {
        elementsGender.forEach(element => {
            element.addEventListener('click', handelSelectGender);
        });
    }

    document.querySelector('.gender__container .selectGender__actions .genderContinue__btn')
        .classList[selectedGender ? 'remove' : 'add']('disabled');

    document.querySelector(`.gender__container .genderContinue__btn`)
        .addEventListener('click', handleClickContinue);

    document.querySelector('.category_item .select__gender')?.addEventListener('keypress', cancelEnterButton);

    /* On click enter */
    const screenPhone = document.querySelector('.gender__container');
    if (screenPhone) {
        screenPhone.addEventListener('keydown', handlePressEnter);
    }
}

function cancelEnterButton(e) {
    if (e.key === 'Enter') {
        e.preventDefault();
    }
}

function handleClickContinue(e) {
    if(showBodyAreaSelection) {
        renderbodySelectionUI(selectedGender || 'non-binary');
        bodyAreaSelectionListeners();
        navigate(SCREEN.BODY_AREA_SELECTION);
    }else{
        staffId ? handleSelectProvider(e) : handleCheckProviders();
    }
}


function handelSelectGender(event) {
    document.querySelector('.category_item .select__gender').focus();
    const elementSelected = selectedGender ? document.getElementById(`${selectedGender}`) : null;
    const currentSelectedGender = event.currentTarget;
    if (elementSelected) {
        selectedGender !== currentSelectedGender.id &&
            elementSelected.classList.remove('gender--selected');
        currentSelectedGender.classList.toggle('gender--selected');
    } else {
        currentSelectedGender.classList.toggle('gender--selected');
    }
    const gender = currentSelectedGender.classList.contains('gender--selected');
    setSelectedGender(gender ? currentSelectedGender.id : null);
    document.querySelector('.gender__container .selectGender__actions .genderContinue__btn')
        .classList[selectedGender ? 'remove' : 'add']('disabled');
}

function handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.gender__container .genderContinue__btn`).classList.contains('disabled')) {
        document.querySelector(`.gender__container .genderContinue__btn`).click();
    }
}